"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpReportOverviewCard: {
        seeReport: 'See sample report',
        ariaLabel: '{{type}} you will see {{summary}}',
    },
};
